<template>
  <div>
    <el-dialog
      :close-on-click-modal="false"
      :visible.sync="deleteDeptVisible"
      width="30%">
      <span> 是否删除 <b>{{ deleteDeptInfo.name }}</b> ？ </span>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" type="info" @click="deleteDeptVisible = false">取 消</el-button>
        <el-button size="small"
                   type="primary"
                   @click="sureDeleteDept(deleteDeptInfo)"
                   :loading="sureLoading">确 定
        </el-button>
      </span>
    </el-dialog>

    <!--机构列表开始-->
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <el-form label-width="100px">
          <el-row>
            <el-col :span="9">
              <el-form-item label="成员名称:" size="small" style="font-weight: 500">
                <el-input class="inputText" v-model="member.name" size="small" @keyup.enter.native="onSubmit" clearable
                          placeholder="请输入成员名称" @clear="onSubmit">
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="9" :offset="1">
              <el-form-item label="机构" size="small">
                <yl-cascader
                  class="inputText"
                  :props="{ checkStrictly: true }"
                  :options="treeDeptData"
                  v-model="member.parentIds"
                  @change="handleDeptChange"
                  :show-all-levels="false"
                  clearable filterable>
                </yl-cascader>
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <div>
                <el-button type="primary" size="small" @click="onSubmit">查询</el-button>
                <el-button size="small" type="info" @click="reset">重置</el-button>
              </div>
            </el-col>
          </el-row>
        </el-form>

      </div>


      <el-table
        ref="tableRef"
        v-loading="loading"
        highlight-current-row
        size="small"
        :data="tableNeedData"
        :span-method="arraySpanMethod"
        @sort-change="sortChange"
        border
        style="width: 100%">
        <el-table-column
          sortable="custom"
          align="center"
          header-align="center"
          prop="userId"
          label="成员名称">
          <template slot-scope="scope">
            <span style="margin-left: 10px">{{ scope.row.name }}</span>
          </template>
        </el-table-column>
        <el-table-column
          sortable="custom"
          align="center"
          header-align="center"
          prop="userId"
          label="机构名称">
          <template slot-scope="scope">
            <span style="margin-left: 10px">{{ scope.row.majorName }}</span>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          header-align="center"
          prop="unMajorName"
          label="非行政机构">
          <template slot-scope="scope">
            <span
              v-if="!scope.row.optBtn">{{ scope.row.unMajorName }}</span>
            <span v-else> <el-button type="info" icon="el-icon-plus" size="medium"
                                     @click="addMemberDeptInfo(scope.row)"></el-button></span>
          </template>
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          align="center"
          header-align="center"
          prop="unRoleName"
          label="非行政机构角色">
        </el-table-column>
        <el-table-column
          align="center"
          header-align="center"
          label="操作"
          width="100"
          fixed="right">
          <template slot-scope="scope">
            <el-dropdown class="el-dropdown-link" v-if="!scope.row.optBtn">
              <el-button class="el-icon-more identity-link" type="info"
                         style="border: 0px;background-color: transparent"></el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item @click.native="updateDept(scope.row)">
                  <i class="el-icon-edit"></i>
                  <el-button style="border:0px !important;" type="text" size="small">维护</el-button>
                </el-dropdown-item>
                <el-dropdown-item @click.native="deleteDept(scope.row)">
                  <i class="el-icon-delete"></i>
                  <el-button style="border:0px !important;" type="text" size="small">删除</el-button>
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </template>

        </el-table-column>

      </el-table>
      <!--机构列表结束-->
      <el-pagination
        style="float: right; padding: 3px 0"
        background
        layout="prev, pager, next"
        :total="pageCount"
        :current-page="currentPage"
        :page-size="pageSize"
        @current-change="clickChangePage"
        @next-click="changePage"
        @prev-click="changePage">
      </el-pagination>
    </el-card>

  </div>
</template>

<script>
//引入formatDatetime方法
import http from "@/utils/axios";
import cookie from "@/utils/cookie";
import {Message} from "element-ui";
import {mapState} from "vuex";
import animation from '@/components/loading/animation'
//获取机构的级联控制器的回显数据
import {getCascaderFullValue} from '@/utils/cascader'

export default {
  name: "List",
  components: {
    animation,
  },
  data() {
    return {
      loadingDataVisible: false,
      superPower: false,
      fileSaveBtnLoading: false,
      showFileList: [],
      fileList: [],
      drawerVisible: false,
      loading: true,
      member: {
        name: '',
        parentName: "",
        parentIds: [],
        parentId: '',
      },
      memberDeptData: [],
      tableNeedData: [],
      //数据页总数
      pageCount: 1,
      //当前页
      currentPage: 1,
      //页数据大小
      pageSize: 10,
      //要删除的机构信息
      deleteDeptInfo: {},
      //删除提示框
      deleteDeptVisible: false,
      //确定按钮的状态
      sureLoading: false,
      // 用来记录需要合并行的下标
      mergeObj: {},
      // 需要合并的表格中的列名
      mergeArr: ['name', 'operation', "userId"]
    }
  },

  //挂载
  mounted() {
    this.getAuth()
    this.initDeptListData()
  },

  watch: {

    //页数变化直接缓存
    currentPage() {
      this.$store.state.memberDepartmentModule.currentPage = this.currentPage
    },

    userPower() {
      this.superPower = this.$store.state.userPowerStore.superPower
    },

    //列表数据更新
    memberDepartmentRlnS(newVal) {
      //关闭加载提示
      this.loading = false
      this.memberDeptData = newVal;
      this.pageCount = this.$store.state.memberDepartmentModule.deptListDataPage
      //组装数据
      this.generateMemberDepartmentData()
    },

    treeDeptData(newVal) {
      //设置回显选中的上级机构
      this.member.parentIds = getCascaderFullValue(newVal, this.member.parentId)
    }

  },

  computed: mapState({
    userPower: state => state.userPowerStore.userPower,
    memberDepartmentRlnS: state => state.memberDepartmentModule.memberDepartmentRlnS,
    treeDeptData: state => state.memberDepartmentModule.treeDeptData,
  }),


  methods: {

    addMemberDeptInfo(user) {
      this.$router.push({
        path: "/user/organization/update",
        query: {userId: user.userId, departmentId: user.unMajorId}
      })
    },

    // getSpanArr方法
    getSpanArr(data) {
      this.mergeArr.forEach((key, index1) => {
        let count = 0; // 用来记录需要合并行的起始位置
        this.mergeObj[key] = []; // 记录每一列的合并信息
        data.forEach((item, index) => {
          // index == 0表示数据为第一行，直接 push 一个 1
          if (index === 0) {
            this.mergeObj[key].push(1);
          } else {
            // 判断当前行是否与上一行其值相等 如果相等 在 count 记录的位置其值 +1 表示当前行需要合并 并push 一个 0 作为占位
            if (item[key] === data[index - 1][key]) {
              this.mergeObj[key][count] += 1;
              this.mergeObj[key].push(0);
            } else {
              // 如果当前行和上一行其值不相等
              count = index; // 记录当前位置
              this.mergeObj[key].push(1); // 重新push 一个 1
            }
          }
        })
      })
    },

    arraySpanMethod({row, column, rowIndex, columnIndex}) {
      // 判断列的属性
      if (this.mergeArr.indexOf(column.property) !== -1) {
        // 判断其值是不是为0
        if (this.mergeObj[column.property][rowIndex]) {
          return [this.mergeObj[column.property][rowIndex], 1]
        } else {
          // 如果为0则为需要合并的行
          return [0, 0];
        }
      }

      //如果改行出现这个optBtn,则将该列的columnIndex === 2
      //占据1行3列
      if (row.optBtn) {
        if (columnIndex === 2) {
          return [1, 3];
        } else {
          return [0, 0];
        }
      }
    },

    //将后端传来的数据组装成前端需要的数据
    generateMemberDepartmentData(val) {
      let tableNeedData = []
      for (let data of (val?val:this.memberDeptData)) {
        //如果没有行政机构的情况
        if (data.departmentRlnVOS.length === 0) {
          let item = {}
          item.userId = data.userId
          item.name = data.name
          item.majorId = data.majorId
          item.majorName = data.majorName
          item.majorTp = data.majorTp
          //添加操作按钮在表格中
          item.optBtn = true
          tableNeedData.push(item)
          //有行政机构的情况
        } else {
          for (let i = 0; i < data.departmentRlnVOS.length; i++) {
            let unMajor = data.departmentRlnVOS[i]
            let item = {}
            item.userId = data.userId
            item.name = data.name
            item.majorId = data.majorId
            item.majorName = data.majorName
            item.majorTp = data.majorTp
            item.id = unMajor.id
            item.unMajorId = unMajor.departmentId
            item.unMajorName = unMajor.name
            item.unMajortp = unMajor.tp
            item.unRoleCode = unMajor.roleCode
            item.unRoleName = unMajor.roleName
            tableNeedData.push(item)
            //添加操作按钮在表格中
            if (i === data.departmentRlnVOS.length - 1) {
              tableNeedData.push({
                userId: data.userId,
                name: data.name,
                optBtn: true
              })
            }

          }
        }
      }
      this.getSpanArr(tableNeedData)
      this.tableNeedData = tableNeedData
    },

    //级联选择器选项发生变化
    handleDeptChange(value) {
      this.member.parentId = value[value.length - 1]
    },

    //sortable="custom" 使得排序点击走此方
    sortChange(val){
      let result = [];
      let dataCurr = JSON.parse(JSON.stringify(this.memberDeptData));
      if (val.order === 'ascending') {
        if (val.prop === 'name') {
          dataCurr.sort((x,y)=> x.name.localeCompare(y.name))
        }else if (val.prop === 'userId'){
          dataCurr.sort((x,y)=> x.majorName.localeCompare(y.majorName))
        }
      }else if (val.order === 'descending'){
        if (val.prop === 'name') {
          dataCurr.sort((x,y)=> y.name.localeCompare(x.name))
        }else if (val.prop === 'userId'){
          dataCurr.sort((x,y)=> y.majorName.localeCompare(x.majorName))
        }
      }
      result = JSON.parse(JSON.stringify(dataCurr));
      this.generateMemberDepartmentData(result);
    },

    initDeptListData() {
      //机构列表数据
      this.memberDeptData = this.$store.state.memberDepartmentModule.memberDepartmentRlnS
      //数据页总数
      this.pageCount = this.$store.state.memberDepartmentModule.deptListDataPage
      this.member.name = this.$store.state.memberDepartmentModule.searchCondition.name
      this.currentPage = this.$store.state.memberDepartmentModule.currentPage
      this.member.parentId = this.$store.state.memberDepartmentModule.searchCondition.parentId
      this.loading = false
      if (this.memberDeptData.length === 0) {
        this.findMemberDepartment()
      } else {
        this.generateMemberDepartmentData()
      }
      this.$store.dispatch("loadingTreeDeptData")
    },

    getAuth() {
      //调用方法之后获取权限设置在vuex中
      this.$store.dispatch("getUserPower").then(value => {
        //获取用户部门管理权限
        this.superPower = this.$store.state.userPowerStore.superPower
      })
    },


    onSubmit() {
      this.currentPage = 1
      this.findMemberDepartment()
    },

    reset() {
      this.member.name = ""
      this.member.parentIds = []
      this.member.parentId = ""
      this.$store.state.memberDepartmentModule.searchCondition.name = ""
      this.$store.state.memberDepartmentModule.searchCondition.parentIds = ""
    },

    //确实删除机构
    sureDeleteDept(dept) {
      this.sureLoading = true
      let obj = {
        token: cookie.getCookie("token"),
        data: {
          userId: dept.userId,
          departmentId: dept.unMajorId
        }
      }
      http.post(window.config.api.baseUrl + '/eims-api/memberDept/delete', obj).then(value => {
        if (value.data.code === '00000') {
          this.findMemberDepartment()
          Message.success({message: "机构删除成功", showClose: true})
        }
      }).finally(() => {
        this.deleteDeptVisible = false
        this.sureLoading = false
      })
    },

    //删除机构信息
    deleteDept(dept) {
      this.deleteDeptInfo = dept
      this.deleteDeptVisible = true
    },

    //编辑机构信息,需要跳转页面
    updateDept(user) {
      this.$router.push({
        path: "/user/organization/update",
        query: {deptId: user.unMajorId, userId: user.userId}
      })
    },

    //点击改变页码
    clickChangePage(currentPage) {
      this.currentPage = currentPage
      this.findMemberDepartment();
    },

    //页码改变之后
    changePage(currentPage) {
      this.currentPage = currentPage
    },

    //查询当前用户机构及其所有子机构的信息
    findMemberDepartment() {
      this.loading = true;
      let obj = {
        token: cookie.getCookie('token'),
        data: {
          pageNum: this.currentPage,
          pageSize: this.pageSize,
          name: this.member.name,
          parentId: this.member.parentId,
        }
      }
      //使用vuex获取数据
      //调用方法之后获取权限设置在vuex中
      this.$store.dispatch("findMemberDepartmentInfo", obj)
    }
  }
}
</script>

<style scoped>

.text {
  font-size: 14px;
}

.item {
  margin-bottom: 18px;
}

.clearfix:before,
.clearfix:after {
  display: table;
  content: "";
}

.clearfix:after {
  clear: both
}

.box-card {
  width: 100%;
  border-radius: 10px
}

.prefixText {
  width: 70px;
  display: inline-block;
  float: left;
  padding-right: 0px;
  font-size: 14px;
  line-height: 28px
}

.inputText {
  display: inline-block;
  width: 82%
}

.identity-link:hover {
  transform: rotate(90deg);
}

.identity-link {
  transform: rotate(0deg);
  transition-duration: .5s;
}

</style>



// WEBPACK FOOTER //
// src/pages/member/MemberDepartment.vue